import { Container, Row, Col, Card, Button, Image, Tab, Tabs } from "react-bootstrap";
import ContentImage from "../component/ContentImage";
import CommunityDevelopmentProjects from "../static/ProjectsData/CommunityDevelopment";
import InternationalCooperationProjects from "../static/ProjectsData/InternationalCooperation";
import BusinessAndEnterpreneurshipProjects from "../static/ProjectsData/BusinessAndEnterpreneurship";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import Reveal from "../component/Reveal";
import RollingNumber from "../component/RollingNumber";
import SponsorsData from "../static/SponsorsData";
import getImageLogosSrcSet from "../helper/ImageKit";
import ImageKit from "../component/ImageKit";
import RunningBanner from "../component/RunningBanner";
import NewsAndUpdates from "../component/NewsAndUpdates";
import UpcomingEvents from "../component/UpcomingEvents";

const Home = () => {
  const navigate = useNavigate();
  let data = [...CommunityDevelopmentProjects, ...InternationalCooperationProjects, ...BusinessAndEnterpreneurshipProjects];
  return (
    <div>
      <Row>
        <Col>
          <div className="right-home-div home-about-preview">
            {/* <img
              className="home-about-us-img"
              loading="eager"
              // 1. The fallback/default source (Desktop size)
              src="https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-1200,f-auto"
              
              // 2. The menu of options for the browser
              srcSet="
                https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-400,f-auto 400w,
                https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-800,f-auto 800w,
                https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-1200,f-auto 1200w,
                https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-1920,f-auto 1920w
              "
              
              // 3. Telling the browser how much space the image takes up
              sizes="(max-width: 768px) 100vw, 1200px"
            /> */}
            <div className="right-home-header-paragraph-div">
              <h1><b>About JCI Lucena</b></h1>
              <p>Lead. Rise. <b className="ron-text-color">R</b>ock<b className="ron-text-color">ON</b>.</p>
              {/* <div className="lead-rise-rock-on">
                <p>Lead. Rise.</p>
                <img src="rock-on-logo.png" className="rock-on-logo"/>
              </div> */}
              {/* replace with Rock On Logo */}
              <p>
                JCI Lucena is a vibrant organization of young active citizens aged 18 to 40, dedicated to creating positive change in Lucena City.
                Established in 1948, we celebrate 77 years of empowering leaders who turn ideas into action.
              </p>
              <p>
                Through leadership development, community projects, and meaningful partnerships, we transform passion into service and service into lasting impact.
              </p>
              <p>
                Join us—be part of a community where leadership meets purpose, and together, we build a better tomorrow.
              </p>
              <div>
                <Button variant="primary" onClick={() => {navigate('/about-us');}}>Learn More</Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Container className="home-container">
        <Row className="home-row">
          <Col>
            {/* use induction pub mat bg for this */}
            {/* <div className="left-home-div">
              <ContentImage
                src="placeholder.png"
              />
              <div className="left-home-header-pagaraph-div">
                <h1><b>Our Creed</b></h1>
                <p className="our-creed-text">That faith in God gives meaning and purpose to human life,</p>
                <p className="our-creed-text">That the brotherhood of man transcends the sovereignity of nations.</p>
                <p className="our-creed-text">That economic justice can be won by freeman through free enterprise.</p>
                <p className="our-creed-text">That government should be of laws rather than of men.</p>
                <p className="our-creed-text">That earth's greatest treasure lies in human personality.</p>
                <p className="our-creed-text">And that service to humanity is the best work of life.</p>
              </div>
            </div>
            <div className="right-home-div">
              <ContentImage
                src="placeholder.png"
              />
              <div className="right-home-header-paragraph-div">
                <h1><b>Mission</b></h1>
                <p>
                  To provide leadership development opportunities that empower young people to create positive change.
                </p>
              </div>
            </div>
            <div className="left-home-div">
              <ContentImage
                src="placeholder.png"
              />
              <div className="left-home-header-pagaraph-div">
                <h1><b>Vision</b></h1>
                <p>
                  To be the foremost global network of young leaders.
                </p>
              </div>
            </div> */}
            {/* <div className="right-home-div">
              <ContentImage
                src="placeholder.png"
              />
              <div className="right-home-header-paragraph-div">
                <h1><b>JCI Prayer</b></h1>
                <p>
                  We reaffirm our conviction that faith in God gives meaning and purpose to human life, may the Lord guide us in all our undertakings.
                </p>
              </div>
            </div> */}
            <Reveal delay={0.2}>
              <div className="impact-card-div">
                <Card className="first impact-card">
                  <Card.Body>
                    <RollingNumber value={78} />
                    <Card.Text className="impact-card-text"> years of service and civic leadership</Card.Text>
                  </Card.Body>
                </Card>
                <Card className="second impact-card">
                  <Card.Body>
                    <RollingNumber value={3000} suffix=" +"/>
                    <Card.Text className="impact-card-text">youth leaders trained and empowered</Card.Text>
                  </Card.Body>
                </Card>
                <Card className="third impact-card">
                  <Card.Body>
                    <RollingNumber value={200} suffix=" +"/>
                    <Card.Text className="impact-card-text">community projects implemented annually</Card.Text>
                  </Card.Body>
                </Card>
                <Card className="fourth impact-card">
                  <Card.Body>
                    <RollingNumber value={50} suffix=" +"/>
                    <Card.Text className="impact-card-text">local, national, and international awards</Card.Text>
                  </Card.Body>
                </Card>
                <Card className=" fifth impact-card">
                  <Card.Img />
                  <Card.Body>
                    <RollingNumber value={50} suffix=" +"/>
                    <Card.Text className="impact-card-text">strong partner organizations and institutions</Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <h1 style={{ textAlign: 'center' }}>Projects</h1>
              <div className="projects-grid">
                {data.map((project) => (
                  (project.IsFeatured === true) &&
                    <Card className="projects-card">
                      <ImageKit 
                        path={project.thumbnail}
                        // ratio={imgPath.aspect}
                        alt={project.title}
                        // className="project-image-main-frame"
                        // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                      />
                      <Card.Body>
                        <Card.Title><h4>{project.title}</h4></Card.Title>
                        <Card.Text>
                          {project.description}
                        </Card.Text>
                        <div className="home-projects-preview-card-button">
                          <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/${project.division}/${project.id}/`);}}>View</Button>
                          {/* maybe mas okay gawin clickable link images */}
                        </div>
                      </Card.Body>
                    </Card>
                ))}
              </div>
              {/* <Tabs
                defaultActiveKey="Current"
                id="uncontrolled-tab-example"
                className="project-tabs mb-3"
              >
                <Tab eventKey="Current" title="Community Development">
                  <div className="projects-grid">
                    {ProjectsData.map((project) => (
                      <Card className="projects-card">
                        <ImageKit 
                          path={project.thumbnail} */}
                          {/* // ratio={imgPath.aspect}
                          // alt={project.title}
                          // className="project-image-main-frame"
                          // ratio="16/9" // You can change this to "4/5" for mobile-first tall images */}
                        {/* /> */}
                        {/* <Card.Body>
                          <Card.Title><h4>{project.title}</h4></Card.Title>
                          <Card.Text>
                            {project.description}
                          </Card.Text>
                          <div className="home-projects-preview-card-button">
                            <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/${project.id}`);}}>View</Button> */}
                            {/* maybe mas okay gawin clickable link images */}
                          {/* </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div> */}
                  {/* might need to use next.js for slug files */}
                {/* </Tab>
                <Tab eventKey="second" title="Business & Entrepreneurship">
                  Tab content for Business and Entrepreneurship. This tab is under construction
                </Tab>
                <Tab eventKey="third" title="Individual Development">
                  Tab content for Individual Development. This tab is under construction
                </Tab>
                <Tab eventKey="fourth" title="International Cooperation">
                  Tab content for International Cooperation. This tab is under construction
                </Tab> */}
                {/* <Tab eventKey="2020" title="2020">
                  Tab content for 2022. This tab is under construction
                </Tab> */}
              {/* </Tabs> */}
              <div className="home-projects-preview-our-projects-button">
                <Button variant="primary" onClick={() => {navigate('/projects');}}>View More Projects</Button>
              </div>
              {/* <div className="swiper-div">
                <Swiper
                  effect={'coverflow'}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={'auto'}
                  initialSlide={1}
                  spaceBetween={20}
                  preventClicks={false}
                  preventClicksPropagation={false}
                  coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                  }}
                  pagination={{ clickable: true }}
                  modules={[EffectCoverflow, Pagination, Navigation]}
                  className="home-preview-projects-swiper"
                >
                  MAP INDIVIDUAL SLIDES HERE
                  {ProjectsData.map((project) => (
                    <SwiperSlide key={project.id} style={{ width: 'auto', height: 'auto' }}>
                      <Card className="home-projects-card" style={{ width: '18rem', height: 'auto'}}>
                        <ImageKit 
                          path={project.thumbnail}
                          // ratio={imgPath.aspect}
                          alt={project.title}
                          // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                        />
                        <Card.Body>
                          <Card.Title><h2>{project.title}</h2></Card.Title>
                          <Card.Text>
                            {project.description}
                          </Card.Text>
                          <div className="home-projects-preview-card-button">
                            <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/${project.id}`); window.scrollTo({top: 0, left: 0, behavior: 'instant'})}}>View</Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="home-projects-preview-our-projects-button">
                  <Button variant="primary" onClick={() => {navigate('/projects');}}>Our Projects</Button>
                </div>
              </div> */}
            </Reveal>
          </Col>
        </Row>
      </Container>
      {/* <div> */}
        {/* <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          navigation={true} // This enables the arrows
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={{ clickable: true }}
          modules={[EffectCoverflow, Pagination, Navigation]}
          className="mySwiper"
        >
          {/* MAP INDIVIDUAL SLIDES HERE */}
          {/* {ProjectsData.map((project) => (
            <SwiperSlide key={project.id} style={{ width: '300px', height: '300px' }}>
              <Link
                to={`/projects/${project.id}`}
                className="project-card"
              >
                <img 
                  src={project.thumbnail} 
                  alt={project.title} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                />
              <h3>{project.title}</h3>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper> */}
          {/* {ProjectsData.map((project) => (
            <Link
              key={project.id}
              to={`/projects/${project.id}`}
              className="project-card"
            >
              <img src={project.thumbnail} alt={project.title} />
            </Link>
          ))} */}
      {/* </div> */}
      <Reveal>
        <div className="the-clarion-div">
          <div className="the-clarion">
            <Image src="https://ik.imagekit.io/wwg4nuz3a/publications/magazine-covers/the-clarion-magazine-cover-june-2026.png?" alt="The Clarion" thumbnail />
            {/* <ContentImage className="the-clarion-img"
              src="The-Clarion-January-Newsletter-Frontpage.jpg"
              style={{ width: '200px', height: '200px' }}
            /> */}
          </div>
          <div className="the-clarion-spacer-div"></div>
          <div className="the-clarion-header-paragraph">
            <h1>Publication: The Clarion</h1>
            <p>
              JCI Clarion Publication serves as the clarion call of the organization—clear, principled, and fearless in delivering truth, fostering dialogue, and inspiring leadership through responsible journalism.
            </p>
            <p>
              For JCI Clarion Publication, Clarion symbolizes:
            </p>
            <ul className="clarion-undordered-list">
              <li><b>Clarity of Voice</b> – a commitment to clear, accurate, and understandable reporting.</li>
              <li><b>Call to Awareness</b> – journalism that informs the community about issues that matter and encourages critical thinking</li>
              <li><b>Truth and Integrity</b> – a strong, unwavering stand for factual, ethical, and responsible journalism.</li>
              <li><b>Leadership and Action</b> – aligning with JCI values by using information as a tool to inspire positive change and civic responsibility.</li>
              <li><b>Independence</b> – a publication that speaks with its own voice, free from undue influence, while remaining accountable.</li>
            </ul>
            <Button variant="primary" onClick={() => {navigate('/our-publication');}}>Publication</Button>
          </div>
            {/* <Button variant="primary" onClick={() => {navigate('/our-publication'); window.scrollTo({top: 0, left: 0, behavior: 'instant'})}}>Our Publication</Button> */} 
        </div>
      </Reveal>
      <Reveal>
        <div className="upcoming-events-div">
          <div className="upcoming-events-header">
            <h1>Upcoming Events</h1>
          </div>
          <div className="home-upcoming-events-div">
            <UpcomingEvents />
          </div>
        </div>
        <div className="news-updates-div">
          <div className="upcoming-events-header">
            <h1>News and Updates</h1>
          </div>
          <div className="home-news-updates">
            <NewsAndUpdates />
          </div>
        </div>
      </Reveal>
      {/* might be better to transfer this to ImpactCards.js later on */}
      <Reveal>
        <div className="our-partner-organizations-div">
          <div className="our-partner-organizations">
            <h1>Sponsors</h1>
            <RunningBanner
              data={SponsorsData}
              className={"sponsor-logos"}
            />
            {/* <Card className="our-partner-organizations-card">
              <Card.Img />
              <Card.Body className="our-partner-organizations-card-body">
                <Card.Title className="our-partner-organizations-card-body-title"><h1>Our Partner Organizations</h1></Card.Title>
                <Row>
                  <div className="sponsors-div">
                    {SponsorsData.map((sponsor) => {
                      const img = getImageLogosSrcSet(sponsor.logoPath);
                      return (
                          <img
                            key={sponsor.id}
                            src={img.src}
                            srcSet={img.srcSet}
                            sizes={img.sizes}
                            alt="Sponsor logo"
                            className="sponsor-logos"
                          />
                      );
                    })}
                  </div>
                </Row>
                <Card.Text className=""></Card.Text>
              </Card.Body>
            </Card> */}
          </div>
        </div>
      </Reveal>
    </div>
  )
}

export default Home;